import styled from 'styled-components';
import bg from './bg.jpg';
import withTheme from '../../Theme';

const asideWidth = 330;
const headerHeight = 70;

export const Container = withTheme((styled.div`
  
`));

export const Header = withTheme((styled.header`
  background: ${({ theme }) => theme.colors.brand};
  padding: 8px;
  height: ${headerHeight}px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  img {
    height: 38px;
  }

  .toggle-aside {
    position: absolute;
    left: 8px;
    color: #1a1a1a;
    display: none;
    @media (max-width: 1300px) {
      display: initial;
    }
  }

  @media (max-width: 1300px) {
    position: fixed;
    top: 0;
    width: 100%;
  }
`));

type AsideProps = {
  screenHeight: number;
}

export const Aside = withTheme((styled.aside<AsideProps>`
  width: ${asideWidth}px;
  padding: 16px;
  box-sizing: border-box;
  height: calc(${({ screenHeight }) => screenHeight}px - ${headerHeight}px);
  background: ${({ theme }) => theme.colors.paper};
  display: flex;
  flex-direction: column;
  position: relative;
  .credits {
    position: absolute;
    bottom: 16px;
    align-self: center;
  }

  .MuiFormLabel-root {
    font-size: .9rem;
  }

  .textfield-board {
    label, select {
      color: ${({ theme }) => theme.colors.primary} !important;
    }
    .MuiInputBase-root{
      &::before, &::after {
        border-color: ${({ theme }) => theme.colors.primary} !important;
      }
    }
  }

  .textfield-addpedal {
    color: ${({ theme }) => theme.colors.secondary} !important;
    label, input {
      color: ${({ theme }) => theme.colors.secondary} !important;
    }
    .MuiInputBase-root{
      &::before, &::after {
        border-color: ${({ theme }) => theme.colors.secondary} !important;
      }
    }
  }

  @media (max-width: 1300px) {
    position: fixed;
    bottom: 0;
    left: -${asideWidth}px;
    transition: .5s;
    &.opened {
      left: 0;
      z-index: 99999;
    }
  }

  @media (max-height: 600px) {
    overflow-y: scroll;
    box-sizing: border-box;
    .credits {
      position: relative;
      margin-top: 32px;
    }
  }
`));

export const Row = styled.div`
  display: flex;
`;

export const UtilArea = withTheme((styled.div<AsideProps>`
  background: url(${bg}) center;
  flex: 1;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  height: calc(${({ screenHeight }) => screenHeight}px - ${headerHeight}px);
  box-sizing: border-box;
  
  .util-wrapper {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;
  }

  overflow: auto;
  padding: 32px 16px;

  @media (max-width: 768px) {
    box-sizing: border-box;
    padding-top: 66px;
    display: block;
  }

  .credits {
    font-size: 0.5em;
    font-weight: normal;
    /* align-self: flex-end;
    position: fixed;
    bottom: 16px;
    left: ${asideWidth + 16}px; */
    margin-top: 16px;
    width: 100%;
    a {
      color: ${({ theme }) => theme.colors.contrast};
    }
  }

  @media (max-width: 1300px) {
    margin-top: ${headerHeight}px;
  }
`));